import axios from 'axios';
import auth from './auth';
import jwt_decode from 'jwt-decode';

function getGroupInfo(){
    var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
    var sessionIdInfo = jwt_decode(jwtToken);
    console.log("Group Info :"+sessionIdInfo['cognito:groups']);
    return sessionIdInfo['cognito:groups'];
}

function getUserInfo(){
    var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
    var sessionIdInfo = jwt_decode(jwtToken);
    console.log("Group Info :"+sessionIdInfo['cognito:groups']);
    const USERINFO_URL = 'https://'+auth.auth.getAppWebDomain() + '/oauth2/userInfo';
    var requestData = {
        headers: {
            'Authorization': 'Bearer '+ jwtToken
        }
    }
    var userInfo = axios.get(USERINFO_URL, requestData);
  
    return userInfo;
}

function getUserToken(){
    return auth.auth.getSignInUserSession().getAccessToken().jwtToken;
}

export default{ 
    getUserToken : getUserToken, 
    getUserInfo : getUserInfo,
    getGroupInfo : getGroupInfo,
    getAPICall : getAPICall
}

function getAPICall(url){
    var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
   
    var requestData = {
        headers: {
            'Authorization': 'Bearer '+ jwtToken,
            'Content-Type': 'application/json'
        }
    }
    var response = axios.get(url, requestData);
  
    return response;
}